/* Open external links in new window */
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].relList.add("noreferrer", "noopener");
  }
}

/* Refresh variant selector to load testers */
jQuery(function () {
  // Initial setup
  var id = $('[name="id"]').val();
  console.log("product id: ", id);
  $('.extra_variant_wrapper[data-id="'+id+'"]').show();
  $('.extra_variant_wrapper[data-id!="'+id+'"]').hide(); 
  
  // Function to update variant wrappers
  function updateVariantWrappers(variantId) {
    if (variantId) {
      console.log("variant changed to: ", variantId);
      $('.extra_variant_wrapper[data-id="'+variantId+'"]').show();
      $('.extra_variant_wrapper[data-id!="'+variantId+'"]').hide(); 
      $('.extra_variant_wrapper[data-id="'+variantId+'"]').each(function(e) {
        var var_id = $(this).find('[name="id"]').data('value');
        $(this).find('[name="id"]').val(var_id);
      });
    }
  }
  
  // Custom quantity button handlers
  function handleQuantityButtons() {
    // Handle tester quantity buttons
    $('.tester-quantity-btn').off('click').on('click', function(e) {
      e.preventDefault();
      var $button = $(this);
      var $wrapper = $button.closest('.quantity-wrapper');
      var $input = $wrapper.find('.tester-quantity-input');
      var action = $button.data('action');
      var currentValue = parseInt($input.val()) || 1;
      var maxValue = parseInt($wrapper.data('max')) || 1;
      var minValue = 1;
      
      if (action === 'increase' && currentValue < maxValue) {
        $input.val(currentValue + 1);
      } else if (action === 'decrease' && currentValue > minValue) {
        $input.val(currentValue - 1);
      }
    });
    
    // Handle sample quantity buttons
    $('.sample-quantity-btn').off('click').on('click', function(e) {
      e.preventDefault();
      var $button = $(this);
      var $wrapper = $button.closest('.quantity-wrapper');
      var $input = $wrapper.find('.sample-quantity-input');
      var action = $button.data('action');
      var currentValue = parseInt($input.val()) || 1;
      var maxValue = parseInt($wrapper.data('max')) || 1;
      var minValue = 1;
      
      if (action === 'increase' && currentValue < maxValue) {
        $input.val(currentValue + 1);
      } else if (action === 'decrease' && currentValue > minValue) {
        $input.val(currentValue - 1);
      }
    });
    
    // Handle bag quantity buttons
    $('.bag-quantity-btn').off('click').on('click', function(e) {
      e.preventDefault();
      var $button = $(this);
      var $wrapper = $button.closest('.quantity-wrapper');
      var $input = $wrapper.find('.bag-quantity-input');
      var action = $button.data('action');
      var currentValue = parseInt($input.val()) || 1;
      var maxValue = parseInt($wrapper.data('max')) || 1;
      var minValue = 1;
      
      if (action === 'increase' && currentValue < maxValue) {
        $input.val(currentValue + 1);
      } else if (action === 'decrease' && currentValue > minValue) {
        $input.val(currentValue - 1);
      }
    });
  }
  
  // Subscribe to the new theme's variant change event
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      var variant = event.data.variant;
      if (variant && variant.id) {
        updateVariantWrappers(variant.id);
        // Re-initialize quantity buttons after variant change
        setTimeout(handleQuantityButtons, 100);
      }
    });
  }
  
  // Fallback for direct option selector changes
  $(".option-selector").on("change", function () {
    setTimeout(function () {
      var id = $('[name="id"]').val();
      updateVariantWrappers(id);
      // Re-initialize quantity buttons after variant change
      handleQuantityButtons();
    }, 50);
  });
  
  // Initial setup of quantity buttons
  handleQuantityButtons();
});

